import { tv } from "../../variants/tv.js";
const subPanelSlots = {
    containerSlot: '',
    subPanelSlot: ''
};
const subPanelEmphasisVariants = {
    none: {
        subPanelSlot: ''
    },
    medium: {
        subPanelSlot: 'bg-primary-3'
    },
    bold: {
        subPanelSlot: 'bg-actionPrimary-8'
    }
};
const subPanelVariants = tv({
    slots: subPanelSlots,
    variants: {
        position: {
            top: {
                containerSlot: 'flex justify-end',
                subPanelSlot: 'border-1 border-primary-5 mb-[-20px] rounded-t-lg px-2 pb-6 pt-1'
            },
            bottom: {
                containerSlot: 'flex justify-start',
                subPanelSlot: 'border-1 border-primary-5 mt-[-20px] rounded-b-lg px-2 pb-1 pt-6'
            }
        },
        emphasis: subPanelEmphasisVariants
    },
    defaultVariants: {
        position: 'top',
        emphasis: 'none'
    }
});
export { subPanelVariants };
